import { render, staticRenderFns } from "./GenderSelect.vue?vue&type=template&id=c3a4c9c8"
import script from "./GenderSelect.vue?vue&type=script&lang=js"
export * from "./GenderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a4c9c8')) {
      api.createRecord('c3a4c9c8', component.options)
    } else {
      api.reload('c3a4c9c8', component.options)
    }
    module.hot.accept("./GenderSelect.vue?vue&type=template&id=c3a4c9c8", function () {
      api.rerender('c3a4c9c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/user/GenderSelect.vue"
export default component.exports